import { render } from "./DropdownComponent.vue?vue&type=template&id=3a7132f5"
import script from "./DropdownComponent.vue?vue&type=script&lang=js"
export * from "./DropdownComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__